import ApolloLogo from '@assets/platforms/apollo.svg';
import FramerLogo from '@assets/platforms/framer.svg';
import GeminiLogo from '@assets/platforms/gemini.svg';
import MagentoLogo from '@assets/platforms/magento.svg';
import ShopifyLogo from '@assets/platforms/shopify.svg';
import WooCommerceLogo from '@assets/platforms/woocommerce.svg';
import WordPressLogo from '@assets/platforms/wordpress.svg';
import styles from './PlatformIcon.module.scss';

export type Platform =
  | 'apollo'
  | 'framer'
  | 'gemini'
  | 'magento'
  | 'shopify'
  | 'woocommerce'
  | 'wordpress'
  | 'unknown';

export interface PlatformIconProps {
  /** The e-commerce platform to display */
  platform: Platform;
  /** Additional CSS classes */
  className?: string;
  /** Alt text for accessibility (defaults to platform name) */
  alt?: string;
}

const platformLogos: Record<Exclude<Platform, 'unknown'>, string> = {
  apollo: ApolloLogo,
  framer: FramerLogo,
  gemini: GeminiLogo,
  magento: MagentoLogo,
  shopify: ShopifyLogo,
  woocommerce: WooCommerceLogo,
  wordpress: WordPressLogo,
};

const platformNames: Record<Platform, string> = {
  apollo: 'Apollo',
  framer: 'Framer',
  gemini: 'Gemini',
  magento: 'Magento',
  shopify: 'Shopify',
  woocommerce: 'WooCommerce',
  wordpress: 'WordPress',
  unknown: 'Unknown',
};

export const PlatformIcon = ({
  platform,
  className = '',
  alt,
}: PlatformIconProps) => {
  // Don't render anything for unknown platform
  if (platform === 'unknown') {
    return null;
  }

  const logo = platformLogos[platform];
  const defaultAlt = platformNames[platform];

  const containerClassName = [styles.container, className].filter(Boolean).join(' ');

  return (
    <div className={containerClassName}>
      <img
        src={logo}
        alt={alt ?? defaultAlt}
        className={styles.logo}
      />
    </div>
  );
};
